import clsx from 'clsx';
import type { ButtonHTMLAttributes } from 'react';

// Кнопки действий из SidePanelFooter: одинаковые в диалоге и его регистрации.
export function ChatActionButton({
	variant = 'primary',
	className,
	...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
	variant?: 'primary' | 'secondary' | 'white';
}) {
	return (
		<button
			type="button"
			{...props}
			className={clsx(
				'flex h-9 cursor-pointer items-center gap-1 rounded-lg px-5 text-sm font-medium transition-colors disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-40',
				variant === 'primary'
					? 'bg-green text-white hover:bg-green-300'
					: variant === 'white'
						? 'border border-gray-4 bg-white text-black hover:bg-gray-5'
						: 'border border-gray-4 bg-gray-5 text-black hover:bg-gray-4/40',
				className,
			)}
		/>
	);
}
